// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';
import { getImageFilePath } from '@tcp/core/src/utils';
import { COUPON_REDEMPTION_TYPE } from '@tcp/core/src/services/abstractors/CnC/CartItemTile';

export const getReachedPerkLevels = (perkLevels, currentPerkLevel) => {
  return perkLevels.slice(0, perkLevels.indexOf(currentPerkLevel) + 1);
};

export const perkPercentage = (currentSpent, nextLevelTotal) => {
  let percentage = (currentSpent / nextLevelTotal) * 100;
  if (percentage > 90) {
    percentage = Math.floor(percentage);
  }
  if (percentage < 10) {
    percentage = Math.ceil(percentage);
  }
  return percentage;
};

export const getPerkStarData = (
  perkLevels,
  reachedPerkLevels,
  currentPerkLevel,
  nextLevelList,
  perkLevelStarMap,
  currentSpent,
  spendLeftForNextPerk,
  perkLevelPeakValueMap
) => {
  return perkLevels.map((item) => {
    return {
      perkLevel: item,
      currentPerkLevel,
      nextPerkLevel: currentPerkLevel === 'star' ? 'rockstar' : nextLevelList[item],
      isPerkReached: reachedPerkLevels.includes(item),
      isDefaultLevel: currentPerkLevel === 'default',
      colorIconShown: currentPerkLevel === 'default' ? false : reachedPerkLevels.includes(item),
      currentLevel: item === currentPerkLevel && item !== 'megastar',
      defaultValue: perkLevelStarMap[item],
      totalSpend: item === currentPerkLevel ? currentSpent : 0,
      spendLeftForNextPerk:
        item === currentPerkLevel ? spendLeftForNextPerk : perkLevelPeakValueMap[item],
      percentage:
        item === currentPerkLevel ? perkPercentage(currentSpent, perkLevelStarMap[item]) : 0,
    };
  });
};

export const getRockstarRaidus = (totalSpend, currentPeak) => {
  return totalSpend > currentPeak - 1;
};

export const getCircleRadius = (currentPeak, nextPeak) => {
  return currentPeak === nextPeak ? 33 : 23;
};

export const getStarRaidus = (currentPeak, nextPeak) => {
  return currentPeak === nextPeak ? 18 : 12;
};

export const getBaseStarRaidus = (currentPeak, nextPeak) => {
  return currentPeak === nextPeak ? 31 : 22;
};

export const getSplitString = (str, delimeter) => {
  return str.split(delimeter);
};

export const getPlacePerkImagePath = (imageUrl) => {
  return `${getImageFilePath()}${imageUrl}`;
};

export const getPerksData = (redeemedAndEarnedPerks, isRedeemedPerk) => {
  if (isEmpty(redeemedAndEarnedPerks)) {
    return [];
  }

  return redeemedAndEarnedPerks.filter((perk) => {
    if (isRedeemedPerk) {
      return perk.isRedeemed;
    }
    return perk.isExpired && !perk.isRedeemed;
  });
};

export const getCurrentPerkIndex = (perkList) => {
  return perkList?.findIndex((item) => {
    return item.perkLevel === item.currentPerkLevel;
  });
};

export const getActivePerksList = (redeemedAndEarnedPerks) => {
  if (isEmpty(redeemedAndEarnedPerks)) {
    return [];
  }
  return (perk) => !perk.isExpired && !perk.isRedeemed;
};

export const getRecentPerksList = (perkList) => {
  if (isEmpty(perkList)) {
    return [];
  }
  const recentPerkList = perkList.filter(
    (coupon) => coupon.offerType === COUPON_REDEMPTION_TYPE.PLACEPERKS
  );

  return recentPerkList.size > 6 ? recentPerkList.slice(0, 6) : recentPerkList;
};
